import { authGuard } from '../../core/guards/auth.guard';
import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: 'elofizetes', children: [
    { path: 'vasarlas', title: 'Coursys-előfizetés', data: {paid: true}, loadComponent: () => import('./features/platform-onboarding/platform-onboarding.component').then(m => m.PlatformOnboardingComponent) },
    { path: 'inditas', title: 'Coursys-próba', loadComponent: () => import('./features/platform-onboarding/platform-onboarding.component').then(m => m.PlatformOnboardingComponent) },
    { path: 'kosar', title: 'Coursys-próba', loadComponent: () => import('./features/platform-onboarding/platform-onboarding.component').then(m => m.PlatformOnboardingComponent) },
    { path: '', pathMatch: 'full', redirectTo: 'kosar' },
  ] },
  { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
  { path: 'admin/elofizetes/fizetes', title: 'Coursys-előfizetés', canActivate: [authGuard], loadComponent: () => import('./features/platform-checkout/platform-checkout.component').then(m => m.PlatformCheckoutComponent) },
  { path: 'admin', title: 'Admin', loadChildren: () => import('./features/admin/admin.module').then(m => m.AdminModule) },
  { path: '', pathMatch: 'full', redirectTo: 'auth/login' },
  { path: '**', redirectTo: 'auth/login' },
];
